import React, {Component} from 'react';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupButton
} from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import * as MomentTZ from 'moment-timezone';
import Moment from 'react-moment';

import * as departureScheduleActions from '../../actions/departureScheduleActions';

import TimezonePicker from 'react-timezone';

class LeaveSoon extends Component {
  constructor(props) {
    super(props);
	
	var timezoneStr = MomentTZ.tz.guess();

	this.state = { 
		collapse: true,
		departureSchedule: {type: 'soon', timezone: timezoneStr}
	};

	this.updateDepartureScheduleState = this.updateDepartureScheduleState.bind(this);
	this.saveDepartureSchedule = this.saveDepartureSchedule.bind(this);
    this.toggle = this.toggle.bind(this);
  }
  
	componentWillReceiveProps(nextProps) {
		this.setState({ departureSchedule: nextProps.departureSchedule });
	}
	
	componentDidMount() {
		var isChanged = false;
		
		if (this.context.preferences.defaultVehicleId != null) {
			this.state.departureSchedule.vehicleId = this.context.preferences.defaultVehicleId;
			isChanged = true;
		} else if (this.context.teslaVehicles.length === 1) {
			this.state.departureSchedule.vehicleId = this.context.teslaVehicles[0].vehicleId;
			isChanged = true;
		}
		
		if (this.context.preferences.defaultTemperatureInC != null) {
	  	  	this.state.departureSchedule.temperatureInC = Number.parseFloat(this.context.preferences.defaultTemperatureInC).toFixed(1);
			isChanged = true;
		}

		if (isChanged) {
			this.setState({
				departureSchedule: this.state.departureSchedule
			});
		}
	}

	updateDepartureScheduleState(event) {
		const departureSchedule = this.state.departureSchedule;
		
		const field = event.target.name;
		if (field === 'vehicleId') {
			departureSchedule.vehicleId = event.target.value;
		} else if (field === 'timezone') {
			departureSchedule.timezone = event.target.value;
		} else if (field === 'temperatureInC') {
			departureSchedule.temperatureInC = event.target.value;
		}
		
		return this.setState({departureSchedule: departureSchedule});
	}

	saveDepartureSchedule(event) {
		event.preventDefault();
		
		var vehicleId = this.state.departureSchedule.vehicleId;
		if (vehicleId == undefined) {
			if (this.context.preferences.defaultVehicleId != null) {
				vehicleId = this.context.preferences.defaultVehicleId;
			} else if (this.context.teslaVehicles.length === 1) {
				vehicleId = this.context.teslaVehicles[0].vehicleId;
			}
			this.state.departureSchedule.vehicleId = vehicleId;
		}
		if (vehicleId == undefined || vehicleId === null || vehicleId === '') {
			alert('Please select a vehicle.');
			return;
		}
		
		var temperatureInC = this.state.departureSchedule.temperatureInC;
		if (temperatureInC == undefined) {
			if (this.context.preferences.defaultTemperatureInC != null) {
		  	  	temperatureInC = Number.parseFloat(this.context.preferences.defaultTemperatureInC).toFixed(1);
			}
			this.state.departureSchedule.temperatureInC = temperatureInC;
		}
		if (temperatureInC == undefined || temperatureInC === null || temperatureInC === '') {
			alert('Please select a temperature.');
			return;
		}
		
		this.props.actions.createDepartureSchedule('deviceId', this.context.authToken, this.state.departureSchedule).then((departureSchedule) => {
			if (departureSchedule.id) {
				this.props.actions.loadDepartureSchedules('deviceId', this.context.authToken);
				
				alert("Soon departure scheduled");
				
				this.props.history.push('/');
			} else {
				alert("Could not save departure schedule");
			}
		})
	}

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }
  
  render() {
	var temperatureUnit = this.context.preferences.temperatureUnit;
	if (temperatureUnit == null) {
		temperatureUnit = "fahrenheit"
	}
	
	var temperatureInC;
	if (this.state.departureSchedule.temperatureInC != null) {
    	temperatureInC = Number.parseFloat(this.state.departureSchedule.temperatureInC);
	} else if (this.context.preferences.defaultTemperatureInC != null) {
	  	temperatureInC = Number.parseFloat(this.context.preferences.defaultTemperatureInC).toFixed(1);
	  	this.state.departureSchedule.temperatureInC = temperatureInC;
	}
	
	if (temperatureInC != null) {
		if (temperatureUnit == "fahrenheit") {
		    // Round to nearest fahrenheit degree
		    var temperatureInF = Math.round((temperatureInC * 9.0 / 5.0) + 32.0);
		    temperatureInC = ((temperatureInF - 32.0) * 5.0 / 9.0).toFixed(1);
	    } else if (temperatureUnit == "celsius") {
		    // Round to nearest celsius half-degree
		    temperatureInC = (Math.round(temperatureInC * 2.0) / 2.0).toFixed(1);
	    }
	}
	
    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs="12" sm="6">
            <Card>
              <CardHeader>
                <strong>Leave Soon</strong>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col xs="12">
                    <FormGroup>
                      <Label htmlFor="vehicleId">Vehicle</Label>
                      <Input type="select" name="vehicleId" id="vehicleId" value={this.state.departureSchedule.vehicleId} onChange={this.updateDepartureScheduleState}>
					  <OptionEmpty show={this.context.teslaVehicles.length !== 1}/>
					  {this.context.teslaVehicles.map(vehicle => {
						  return (
                        <option value={vehicle.vehicleId} key={vehicle.vehicleId}>{vehicle.displayName}</option>
						  );
					  })}
                      </Input>
					  <MessageNoVehicles show={this.context.teslaVehicles.length === 0}/>
                    </FormGroup>
				  </Col>
				</Row>
				<Row>
				  <Col xs="12">
                    <FormGroup>
                      <Label htmlFor="temperatureInC">Temperature</Label>
                      <Input type="select" name="temperatureInC" id="temperatureInC" value={temperatureInC} onChange={this.updateDepartureScheduleState}>
                        <option></option>
					      <OptionsTemperatureUnitFahrenheit show={temperatureUnit === 'fahrenheit'}/>
					      <OptionsTemperatureUnitCelsius show={temperatureUnit === 'celsius'}/>
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <Button 
					id="submit"
					type="submit" 
					size="sm" 
					color="primary" 
					onClick={this.saveDepartureSchedule}><i className="fa fa-dot-circle-o"></i> Save</Button>
              </CardFooter>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs="12" sm="6">
            <Card>
              <CardHeader>
                <strong>Next Departure</strong>
              </CardHeader>
              <CardBody>
				<Row>
                  <Col xs="12">
					  <NextDeparture departureCalendar={this.context.departureCalendars[0]} temperatureUnit={temperatureUnit}/>
				  </Col>
				</Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

function OptionEmpty(props) {
	if (!props.show) {
		return null;
	}
	
  	return (
  		<option value=""></option>
  	);
}

function MessageNoVehicles(props) {
	if (!props.show) {
		return null;
	}
	
  	return (
  		<small>No vehicles found in Tesla account. Please check your Tesla credentials in Settings.</small>
  	);
}

function OptionsTemperatureUnitFahrenheit(props) {
	if (!props.show) {
		return null;
	}
	
  	return (
		<React.Fragment>
          <option value="15.6">60F</option>
          <option value="16.2">61F</option>
          <option value="16.7">62F</option>
          <option value="17.2">63F</option>
          <option value="17.8">64F</option>
          <option value="18.3">65F</option>
          <option value="18.9">66F</option>
          <option value="19.4">67F</option>
          <option value="20.0">68F</option>
          <option value="20.6">69F</option>
          <option value="21.1">70F</option>
          <option value="21.7">71F</option>
          <option value="22.2">72F</option>
          <option value="22.8">73F</option>
          <option value="23.3">74F</option>
          <option value="23.9">75F</option>
          <option value="24.4">76F</option>
          <option value="25.0">77F</option>
          <option value="25.6">78F</option>
          <option value="26.1">79F</option>
          <option value="26.7">80F</option>
          <option value="27.2">81F</option>
          <option value="27.8">82F</option>
		</React.Fragment>
  	);
}

function OptionsTemperatureUnitCelsius(props) {
	if (!props.show) {
		return null;
	}
	
  	return (
		<React.Fragment>
          <option value="15.5">15.5C</option>
          <option value="16.0">16.0C</option>
          <option value="16.5">16.5C</option>
          <option value="17.0">17.0C</option>
          <option value="17.5">17.5C</option>
          <option value="18.0">18.0C</option>
          <option value="18.5">18.5C</option>
          <option value="19.0">19.0C</option>
          <option value="19.5">19.5C</option>
          <option value="20.0">20.0C</option>
          <option value="20.5">20.5C</option>
          <option value="21.0">21.0C</option>
          <option value="21.5">21.5C</option>
          <option value="22.0">22.0C</option>
          <option value="22.5">22.5C</option>
          <option value="23.0">23.0C</option>
          <option value="23.5">23.5C</option>
          <option value="24.0">24.0C</option>
          <option value="24.5">24.5C</option>
          <option value="25.0">25.0C</option>
          <option value="25.5">25.5C</option>
          <option value="26.0">26.0C</option>
          <option value="26.5">26.5C</option>
          <option value="27.0">27.0C</option>
          <option value="27.5">27.5C</option>
          <option value="28.0">28.0C</option>
		</React.Fragment>
  	);
}

function NextDeparture(props) {
	if (!props.departureCalendar) {
		return null;
	}
	
	var temperatureUnit = props.temperatureUnit;
	if (temperatureUnit == null) {
		temperatureUnit = "fahrenheit"
	}
	var temperatureInC;
	if (props.departureCalendar.temperatureInC != null) {
		temperatureInC = Number.parseFloat(props.departureCalendar.temperatureInC);
	}

	var temperatureStr = "";
  
	if (temperatureInC != null) {
	  	if (temperatureUnit == "fahrenheit") {
	      	// Round to nearest fahrenheit degree
	      	temperatureStr = Math.round((temperatureInC * 9.0 / 5.0) + 32.0) + "F";
	  	} else if (temperatureUnit == "celsius") {
	      		// Round to nearest celsius half-degree
	      temperatureStr = (Math.round(temperatureInC * 2.0) / 2.0).toFixed(1) + "C";
	  	}
	}

  	return (
  		<span><Moment format='LLLL' tz={props.departureCalendar.timezone}>{props.departureCalendar.departureTime}</Moment> {temperatureStr}</span>
  	);
}

function mapStateToProps(state, ownProps) {
	var timezoneStr = MomentTZ.tz.guess();
	var departureSchedule = {type: 'soon', timezone: timezoneStr};
    return {departureSchedule: departureSchedule};
} 

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(departureScheduleActions, dispatch)
	}
}

LeaveSoon.contextTypes = {
	authToken: PropTypes.string.isRequired,
	teslaVehicles: PropTypes.array.isRequired,
	preferences: PropTypes.object.isRequired,
	departureCalendars: PropTypes.array.isRequired
}

LeaveSoon.propTypes = {
	actions: PropTypes.object.isRequired,
};

export default compose(
	connect(mapStateToProps, mapDispatchToProps),
	withRouter
)(LeaveSoon);



// WEBPACK FOOTER //
// ./src/views/LeaveSoon/LeaveSoon.js